/* Tasting-Box-Exklusivität: Liegt die Tasting-Box im Warenkorb, werden alle
   anderen Produkte entfernt. Die Box ist ein alleinstehendes Kennenlern-
   Angebot und soll nicht mit Abo-Gerichten oder anderen Artikeln gemischt
   bestellt werden.
   Greift (a) nach jedem Add-to-Cart (Pub/Sub cartUpdate aus product-form.js)
   und (b) einmal beim Seitenaufbau, falls ein gemischter Warenkorb aus einer
   früheren Session übrig ist. */
(function () {
  'use strict';

  var TASTING_HANDLE = 'tasting-box-mixed';
  var running = false;

  function refreshCartUI(state) {
    try {
      var sections = state && state.sections;
      if (sections && sections['cart-drawer']) {
        var current = document.getElementById('CartDrawer');
        var fresh = new DOMParser()
          .parseFromString(sections['cart-drawer'], 'text/html')
          .querySelector('#CartDrawer');
        if (current && fresh) current.innerHTML = fresh.innerHTML;
      }
      if (sections && sections['cart-icon-bubble']) {
        var bubbleEl = document.getElementById('cart-icon-bubble');
        var freshB = new DOMParser()
          .parseFromString(sections['cart-icon-bubble'], 'text/html')
          .querySelector('.shopify-section');
        if (bubbleEl && freshB) bubbleEl.innerHTML = freshB.innerHTML;
      }
    } catch (e) { /* Anzeige-Refresh ist best effort; der Warenkorb selbst stimmt. */ }
    // Auf der Warenkorb-Seite die serverseitig gerenderte Liste neu laden.
    if (/\/cart(\/|$|\?)/.test(window.location.pathname + '?')) window.location.reload();
  }

  function enforce() {
    if (running) return;
    running = true;
    fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var hasTasting = items.some(function (i) { return i.handle === TASTING_HANDLE; });
        if (!hasTasting) return null;
        var updates = {};
        items.forEach(function (i) {
          if (i.handle !== TASTING_HANDLE) updates[i.key] = 0;
        });
        if (!Object.keys(updates).length) return null;
        return fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        }).then(function (r) { return r.json(); }).then(refreshCartUI);
      })
      .catch(function (e) { console.warn('[tasting-guard]', e); })
      .finally(function () { running = false; });
  }

  // Nach jedem Add-to-Cart prüfen (product-form.js publiziert cartUpdate).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { enforce(); });
  }

  // Einmal beim Laden — räumt gemischte Warenkörbe aus früheren Sessions auf.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enforce(); });
  } else {
    enforce();
  }
})();
